import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "d-flex flex-row flex-wrap align-items-center" }
const _hoisted_2 = { class: "pageCaption ps-2" }
const _hoisted_3 = {
  key: 0,
  class: "spinner-border ms-2",
  role: "status"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["disabled", "title"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-export-to-pdf" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["disabled", "title"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-envelope" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "alert alert-primary fw-bold ms-4"
}
const _hoisted_14 = { class: "countLabel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectParticipationSearchWidget = _resolveComponent("ProjectParticipationSearchWidget")!
  const _component_ProjectParticipationListWidget = _resolveComponent("ProjectParticipationListWidget")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("project.participation.page.caption")), 1),
      (this.securityInfo.mayExportPdf)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (this.loadingPdf)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  disabled: this.disabled,
                  class: "btn btn-sm btn-outline-secondary ms-3",
                  "data-bs-toggle": "tooltip",
                  title: _ctx.$t('general.export.pdf'),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (this.exportToPdf()))
                }, _hoisted_8, 8, _hoisted_6))
          ], 64))
        : _createCommentVNode("", true),
      (this.securityInfo.mayEmailAllParticipations)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            disabled: this.disabled,
            class: "btn btn-sm btn-outline-secondary ms-2",
            "data-bs-toggle": "tooltip",
            title: _ctx.$t('project.participation.page.mailToAllToolTip'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (this.openEmailPage()))
          }, _hoisted_11, 8, _hoisted_9))
        : _createCommentVNode("", true),
      (this.securityInfo.mayInsertParticipation)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            type: "button",
            disabled: this.disabled,
            class: "ms-auto me-3 btn btn-secondary",
            form: "",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (this.addParticipation()))
          }, _toDisplayString(_ctx.$t("project.participation.page.newButtonCaption")), 9, _hoisted_12))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ProjectParticipationSearchWidget, {
      disabled: this.disabled,
      ref: "searchWidget",
      projectId: this.ctx.activeProjectId,
      buek: this.buek,
      searchModel: this.searchModel,
      onDoSearch: _ctx.doSearch
    }, null, 8, ["disabled", "projectId", "buek", "searchModel", "onDoSearch"]),
    (this.participantMessages.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.participantMessages, (message) => {
            return (_openBlock(), _createElementBlock("div", { key: message }, _toDisplayString(message), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ProjectParticipationListWidget, {
      disabled: this.disabled,
      organisationParticipationInfos: this.organisationParticipationInfos,
      editInfo: this.editInfo,
      quickFilter: _ctx.quickFilter,
      securityInfo: this.securityInfo,
      menuSection: this.menuSection,
      buek: this.buek,
      onDoEdit: _ctx.doEdit,
      onDoSearch: _ctx.doSearch,
      onRemoveParticipation: _ctx.removeParticipation
    }, null, 8, ["disabled", "organisationParticipationInfos", "editInfo", "quickFilter", "securityInfo", "menuSection", "buek", "onDoEdit", "onDoSearch", "onRemoveParticipation"]),
    _createElementVNode("div", _hoisted_14, _toDisplayString(this.countLabelString), 1)
  ], 64))
}